import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ComponentFactory,
  ViewChildren,
  forwardRef,
  QueryList,

} from "@angular/core";
import { ModalComponent } from "ng2-bs3-modal";
import { IxsReportComponent } from "../ixs-report/ixs-report.component";
import { SyncValue } from "../../core/service/syncdata.service";
import { IXSDropdownComponent } from "../dropdown/dropdown.component";
import { ReportService } from "../ixs-report/ixs-report.service";

@Component({
  selector: "ixs-printviewer",
  templateUrl: "ixs-printviewer.component.html"
})
export class IxsPrintviewerComponent {
  // @ViewChild("printViewer") public printViewer: ModalComponent;
  @ViewChildren(forwardRef(() => ModalComponent))
  public printViewer: QueryList<ModalComponent>;
  @ViewChild("report", { read: ViewContainerRef }) container;
  componentRef: any;
  private reportTitle = "";
  private reportCode: string;
  ReportDtl: any = [];

  constructor(private resolver: ComponentFactoryResolver, private reportservice: ReportService) { }

  public async openReport(
    reportCode: string,
    reportTitle: string,
    showCriteria: boolean,
    isCollapsed: boolean,
    defaultValues: Array<SyncValue>,
    isAutoGenerated: boolean = true,
    // reporttype: number = 1
  ) {
    this.reportCode = reportCode;
    await this.getReportType(this.reportCode);
    if (this.ReportDtl)
      var data = this.ReportDtl[0];

    this.reportTitle = reportTitle;
    this.container.clear();
    const factory: ComponentFactory<
      any
    > = this.resolver.resolveComponentFactory(IxsReportComponent);
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.defaultValues = defaultValues;
    this.componentRef.instance.isAutoGenerated = isAutoGenerated;
    this.componentRef.instance.isCollapsed = isCollapsed;
    this.componentRef.instance.showCriteria = showCriteria;
    this.componentRef.instance.reportCode = reportCode;

    if (this.printViewer && this.printViewer.last) {
      if (data && data.islandscape === true) {
        const dialog: HTMLElement = this.printViewer.last.element.nativeElement.children[0];
        const content: HTMLElement = this.printViewer.last.element.nativeElement.children[0];
        if (dialog && content) {
          dialog.style.width = "1220px";
          content.style.width = "1220px";
        }
        this.componentRef.instance.height = "1020px";
        this.printViewer.last.open();
      }
      else {
        const dialog: HTMLElement = this.printViewer.last.element.nativeElement.children[0];
        const content: HTMLElement = this.printViewer.last.element.nativeElement.children[0];
        if (dialog && content) {
          dialog.style.width = "950px";
          content.style.width = "950px";
        }
        this.componentRef.instance.height = "1350px";
        this.printViewer.last.open();
      }
    }
  }

  async ngOnInit() {
    if (this.printViewer && this.printViewer.last) {
      this.printViewer.last.backdrop = "static";
      this.printViewer.last.keyboard = true;
    }
  }

  async innerClose() {
    if (this.printViewer && this.printViewer.last) {
      this.printViewer.last.keyboard = false;
      $(".modal-backdrop").remove(':last');
      this.printViewer.last.close();
    }
  }

  async getReportType(code) {
    this.ReportDtl = [];
    const dto = await this.reportservice.GetReportType(code);
    if (dto.IsSuccess) {
      this.ReportDtl = dto.Data;
    } else {
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/ixs-printviewer/ixs-printviewer.component.ts